<div class="page-overlay-wrapper" *ngIf="showSpinner">
    <p-progressSpinner></p-progressSpinner>
</div>